import axios from 'axios';
import { BaseUrl } from '../config';
import { toast } from 'react-toastify';
// import { useToast } from '../hook/use-toast';


const axiosInstance = axios.create({
      baseURL: BaseUrl+'/api',
});

const GLOBAL_TOAST_ID = "GLOBAL_API_ERROR";
const GLOBAL_ERRORS = [500, 502, 503, 504];

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    const status = error.response?.status;

    let message = "Une erreur est survenue.";

    // Erreur réseau (API inaccessible, timeout...)
    if (!error.response) {
      if (!toast.isActive(GLOBAL_TOAST_ID)) {
        toast.error("Impossible de joindre le serveur.", {
          toastId: GLOBAL_TOAST_ID,
          position: "top-right",
          autoClose: 3000,
        });
      }

      return Promise.reject(error);
    }

    // Erreurs serveur (une seule notification)
    if (GLOBAL_ERRORS.includes(status)) {
      message =
        error.response.data?.message ||
        "Le serveur rencontre un problème. Veuillez réessayer plus tard.";

      if (!toast.isActive(GLOBAL_TOAST_ID)) {
        toast.error(message, {
          toastId: GLOBAL_TOAST_ID,
          position: "top-right",
          autoClose: 3000,
        });
      }

      return Promise.reject(error);
    }

    // Erreurs métier (chaque requête affiche son propre message)
    switch (status) {
      case 400:
        message = error.response.data?.message || "Requête invalide.";
        break;

      case 401:
        message = error.response.data?.message || "Veuillez vous reconnecter.";
        break;

      case 403:
        message = error.response.data?.message || "Accès refusé.";
        break;

      case 404:
        message = error.response.data?.message || "Ressource introuvable.";
        break;

      case 422:
        message = error.response.data?.message || "Les données sont invalides.";
        break;

      default:
        message =
          error.response.data?.message || "Une erreur est survenue.";
    }

    toast.error(message, {
      position: "top-right",
      autoClose: 3000,
    });

    return Promise.reject(error);
  }
);

// 👉 Interceptor des requêtes : ajoute le token si présent
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('accessToken');
//     if (token && config.headers) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// 👉 Interceptor des réponses : gestion des erreurs + refresh token
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // Si token expiré et qu'on n'a pas déjà tenté un refresh
//     if (
//       error.response?.status === 401 &&
//       !originalRequest._retry &&
//       localStorage.getItem('refreshToken')
//     ) {
//       originalRequest._retry = true;

//       try {
//         const refreshToken = localStorage.getItem('refreshToken');

//         const res = await axios.post('http://localhost:8000/api/refresh-token.php', {
//           refreshToken,
//         });

//         const newAccessToken = res.data.accessToken;
//         localStorage.setItem('accessToken', newAccessToken);

//         // On rejoue la requête originale avec le nouveau token
//         originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
//         return axiosInstance(originalRequest);
//       } catch (refreshError) {
//         // En cas d’échec, on logout
//         localStorage.removeItem('accessToken');
//         localStorage.removeItem('refreshToken');
//         window.location.href = '/login';
//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

export default axiosInstance;